// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1ZJz8","error":"Textarea_error__b5fEB","readonly":"Textarea_readonly__xTCmV","disabled":"Textarea_disabled__3R2Lu"};